import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 28px;\n  color: ", ";\n  font-size: 12px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-image: linear-gradient(\n    to right,\n    ", ",\n    ", "\n  );\n  transition: all 300ms;\n  width: ", "%;\n  border-radius: 0 100px 100px 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: #f5f5f5;\n  height: 4px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  z-index: 1;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 4px;\n  left: 1px;\n  position: absolute;\n  right: 1px;\n  z-index: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin: 0 40px;\n  position: relative;\n  width: 346px;\n  max-width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import Color from 'color';
import { compose, defaultProps, withHandlers, withProps } from 'recompose';
import styled from '../../utils/styling/styled-components';
import { Step } from './Step';
var enhance = compose(defaultProps({
  follow: true
}), withProps(function (_ref) {
  var endColor = _ref.endColor,
      index = _ref.index,
      startColor = _ref.startColor,
      steps = _ref.steps,
      progress = _ref.progress;
  return {
    endColor: endColor ? endColor : '#74c947',
    progress: progress ? progress / 100 : index / (steps.length - 1),
    startColor: startColor ? startColor : '#17a77b'
  };
}), withHandlers({
  calcStepColor: function calcStepColor(_ref2) {
    var current = _ref2.index,
        endColor = _ref2.endColor,
        startColor = _ref2.startColor;
    return function (index) {
      var color = '#f5f5f5';

      if (index <= current) {
        color = Color(startColor).mix(Color(endColor), index / current || 0).string();
      }

      return color;
    };
  }
}));
var Container = styled.div(_templateObject());
var BarContainer = styled.div(_templateObject2());
var Bar = styled.div(_templateObject3());
var StepBar = styled(Bar)(_templateObject4(), function (props) {
  return props.startColor;
}, function (props) {
  return props.endColor;
}, function (props) {
  return props.progress * 100;
});
var StepContainer = styled.div(_templateObject5());
var FloatingStepLabel = styled.span(_templateObject6(), function (props) {
  return props.theme.colors.stone;
});
var DiscreteProgressBar = enhance(function (_ref3) {
  var calcStepColor = _ref3.calcStepColor,
      className = _ref3.className,
      complete = _ref3.complete,
      endColor = _ref3.endColor,
      follow = _ref3.follow,
      current = _ref3.index,
      progress = _ref3.progress,
      responsiveSteps = _ref3.responsiveSteps,
      showAllLabels = _ref3.showAllLabels,
      showPreviousLabels = _ref3.showPreviousLabels,
      startColor = _ref3.startColor,
      steps = _ref3.steps;
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(BarContainer, null, /*#__PURE__*/React.createElement(Bar, null), /*#__PURE__*/React.createElement(StepBar, {
    endColor: endColor,
    startColor: startColor,
    progress: progress
  })), /*#__PURE__*/React.createElement(StepContainer, null, steps.map(function (step, index) {
    var renderLabels = function renderLabels() {
      var labels;

      if (showPreviousLabels) {
        if (index <= current && follow) {
          labels = step.label;
        } else {
          labels = null;
        }
      } else if (showAllLabels) {
        labels = step.label;
      } else if (index === current && follow) {
        labels = step.label;
      } else {
        labels = null;
      }

      return labels;
    };

    return /*#__PURE__*/React.createElement(Step, {
      bgColor: calcStepColor(index),
      isChecked: index < current,
      complete: index === current && complete,
      key: step.label || index,
      label: renderLabels(),
      responsive: responsiveSteps
    });
  })), !follow && /*#__PURE__*/React.createElement(FloatingStepLabel, null, steps[current].label));
});
export { DiscreteProgressBar };